module.exports = __webpack_public_path__ + "img/pms1.f9b016a.jpg";